import React from 'react';
import ReactDOM from 'react-dom';
import charWatchTrack from '../shared/CharWatchTrack';

class UcTrack extends React.Component {
    render() {
        return (
            <div></div>
        );
    }
}

export default charWatchTrack(UcTrack, 'uc', 'track');


// WEBPACK FOOTER //
// ./src/components/sections/uc/UcTrack.js